export class HTTPStatusType {
  static IDLE = "Idle";
  static PENDING = "Pending";
  static FULFILED = "Fulfiled";
  static REJECTED = "Rejected";
}
